module.exports = __webpack_public_path__ + "static/img/ic_empty_network@3x.8d979de3.png";